<template>
  <section class="equity-calculator-insights">
    <table class="table">
      <thead>
        <tr>
          <header-cell v-bind:profitable="isCallProfitable(4, 1)">
            4:1 pot odds
          </header-cell>
          <header-cell v-bind:profitable="isCallProfitable(3, 1)">
            3:1 pot odds
          </header-cell>
          <header-cell v-bind:profitable="isCallProfitable(2, 1)">
            2:1 pot odds
          </header-cell>
          <header-cell v-bind:profitable="isCallProfitable(3, 2)">
            3:2 pot odds
          </header-cell>
          <header-cell v-bind:profitable="isCallProfitable(1, 1)">
            1:1 pot odds
          </header-cell>
        </tr>
      </thead>
      <tbody>
        <tr>
          <table-cell v-bind:profitable="isCallProfitable(4, 1)">
            20%
          </table-cell>
          <table-cell v-bind:profitable="isCallProfitable(3, 1)">
            25%
          </table-cell>
          <table-cell v-bind:profitable="isCallProfitable(2, 1)">
            33.3%
          </table-cell>
          <table-cell v-bind:profitable="isCallProfitable(3, 2)">
            40%
          </table-cell>
          <table-cell v-bind:profitable="isCallProfitable(1, 1)">
            50%
          </table-cell>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import HeaderCell from '@/components/hit-calculator/five-card-hands-section/insights/header-cell';
import TableCell from '@/components/hit-calculator/five-card-hands-section/insights/table-cell';

export default {
  name: 'equity-calculator-insights',
  components: {
    'header-cell': HeaderCell,
    'table-cell': TableCell,
  },
  props: ['equity', 'hasSimulationBeenRun'],
  methods: {
    isCallProfitable: function (reward, risk) {
      if (!this.hasSimulationBeenRun) {
        return null;
      }

      let howOftenCallNeedsToWork = this._getHowOftenCallNeedsToWork(reward, risk);

      return this.equity > howOftenCallNeedsToWork;
    },
    _getHowOftenCallNeedsToWork: function (reward, risk) {
      return (risk / (risk + reward)) * 100;
    },
  },
};
</script>

<style lang="scss" scoped>
  @media (min-width: 992px) {
    th {
      overflow-x: visible;
      max-width: 71px;
      white-space: nowrap;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/equity-calculator/insights.vue